const Datasource = () => {
  return 'Datasource!';
};

export default Datasource;
